import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideImages = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16" />
      <path d="M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2" />
      <circle cx={13} cy={7} r={1} fill="currentColor" />
      <rect width={14} height={14} x={8} y={2} rx={2} />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideImages);
const Memo = memo(ForwardRef);
export default Memo;
